import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';

interface Request {
  clientId: string;
  folderId: string;
  parentFolder: null;
  visibilityLevel: Nullable<
    'OPEN' | 'OPEN_NO_EDIT' | 'OPEN_NO_EDIT_DOWNLOAD' | 'RESTRICTED'
  >;
  folderAccessList: {
    members: any[];
    departments: any[];
  }[];
  departmentAccessList: any[];
}

export const updateFolderAccessSettings = async ({
  clientId,
  folderId,
  parentFolder,
  visibilityLevel,
  folderAccessList,
  departmentAccessList,
}: Request) => {
  const params = { params: { client_id: clientId } };

  const response = await pilot.put(
    `/folder/update/${folderId}/`,
    {
      parent_folder: parentFolder,
      folder_name: 'root',
      id: folderId,
      visibility_level: visibilityLevel,
      folder_access_list: {
        members: folderAccessList,
        departments: departmentAccessList,
      },
    },
    params,
  );
  return response;
};
